import { render, staticRenderFns } from "./TableScrollNavigator.vue?vue&type=template&id=337a94e4&scoped=true"
import script from "./TableScrollNavigator.vue?vue&type=script&lang=js"
export * from "./TableScrollNavigator.vue?vue&type=script&lang=js"
import style0 from "./TableScrollNavigator.vue?vue&type=style&index=0&id=337a94e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337a94e4",
  null
  
)

export default component.exports